/** Tracks session-timeout grace period so the UI can show a modal before logout. */

let pending = false;
let reason = 'idle';
const listeners = new Set();

export function isSessionTimeoutPending() {
  return pending;
}

export function getSessionTimeoutReason() {
  return reason;
}

export function requestSessionTimeout(nextReason = 'token-expired') {
  if (pending) return;
  pending = true;
  reason = nextReason;
  listeners.forEach((fn) => {
    try {
      fn({ reason: nextReason });
    } catch {
      /* listener error */
    }
  });
}

export function clearSessionTimeoutPending() {
  pending = false;
  reason = 'idle';
}

export function subscribeSessionTimeout(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
